// const lenis = new Lenis()

// // lenis.on('scroll', (e) => {
// //   console.log(e)
// // })

// function raf(time) {
//   lenis.raf(time)
//   requestAnimationFrame(raf)
// }

// requestAnimationFrame(raf)

const SIZE = {
  width: window.innerWidth,
  height: window.innerHeight
}

/* ==================== PAGE PUB ==================== */

const hash = window.location.hash;
const PUB = hash === "#pub";

if(PUB) {
  for(let element of document.querySelectorAll('.Pub')) {
    element.classList.remove('Pub');
  }
  for(let element of document.querySelectorAll('.NotPub')) {
    element.remove();
  }
}

// ==================== UTILS ==================== //

const lazyImages = document.querySelectorAll('.lazy');

const lazyLoad = () => {
  lazyImages.forEach(image => {
    if (image.offsetTop < SIZE.height + window.scrollY) {
      image.src = image.dataset.src;
      image.classList.remove('lazy');
    }
  });
}

lazyLoad();

window.addEventListener('scroll', lazyLoad);

const removeClass = (collection, className) => {
  for(let elt of document.querySelectorAll(collection)) {
    elt.classList.remove(className);
  }
}

gsap.registerPlugin(ScrollTrigger);

const splitText = element => {
  const text = element.textContent;
  const words = text.split(' ');
  const spans = words.map(word => {
    const letters = word.split('');
    const letterSpans = letters.map(letter => `<span class="letter">${letter}</span>`);
    return `<span class="word">${letterSpans.join('')}</span>`;
  });
  element.innerHTML = spans.join(' ');
}

for(let heading of document.querySelectorAll('.split')) {
  splitText(heading);
}

const animateLetters = (element) => {

  gsap.to( element.querySelectorAll('span.letter'), { opacity: 1, y: 0, duration: 1, stagger: 0.02, ease: 'elastic.out(1, 0.65)' } );
  
}

animateLetters(document.querySelector('.home-hero .heading-1'));

for(let section of document.querySelectorAll('.section')) {

  let i=0;

  for(let split of section.querySelectorAll('.split')) {

    setTimeout(() => {

      ScrollTrigger.create({
        trigger: split,
        start: 'top 50%',
        onEnter: () => animateLetters(split)
      });

    }, i*500);

    i++;

  }

}

// ==================== PARTNERS ==================== //

class PartnersSlider extends HTMLElement {
  
  constructor() {
    super();
    this.setSlider();
  }

  setSlider() {
    new Splide(this, {
      type   : 'loop',
      perPage: 6,
      arrows: false,
      pagination: false,
      autoplay: true,
      interval: 2000,
      breakpoints: {
        640: {
          perPage: 3
        },
        768: {
          perPage: 5
        }
      }
    } ).mount();
  }

}

customElements.define('partners-slider', PartnersSlider);

// ==================== HOME HERO ==================== //

class HomeHeroSlider extends HTMLElement {
  
  constructor() {
    super();
    this.setSlider();
    this.setTimeline();
  }

  setSlider() {
    new Splide( this, {
      type: 'loop',
      perPage: 4,
      arrows: false,
      pagination: true,
      breakpoints: {
        640: {
          perPage: 2
        }
      }
    } ).mount();
  }

  setTimeline() {

    if(SIZE.width > 1024) {

      this.timeline = gsap.timeline();
      this.timeline.add('start');
      this.timeline.fromTo('.section.home-hero .box.left', { y: 100, rotate: -5 }, { y: -100, rotate: -10, duration: 1, ease: Power0.easeNone }, 'start');
      this.timeline.fromTo('.section.home-hero .box.center', { y: 100 }, { y: -200, duration: 1, ease: Power0.easeNone }, 'start');
      this.timeline.fromTo('.section.home-hero .box.right', { y: 100, rotate: 5 }, { y: -100, rotate: 10, duration: 1, ease: Power0.easeNone }, 'start');
  
      ScrollTrigger.create({
        trigger: '.section.home-hero',
        animation: this.timeline,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
      });

    }
    
  }

}

customElements.define('home-hero-slider', HomeHeroSlider);

const removeCollection = collection => {
  for(let elt of collection) {
    elt.remove();
  }
}
  
const getRandomIntBetween = (min, max) => {
  let difference = max - min;
  let rand = Math.random();
  rand = Math.floor( rand * difference);
  rand = rand + min;
  return rand;
}

const getRandomInterval = (value) => {
  return getRandomIntBetween(value - 5, value + 5);
}

// =================== CARDS =================== //

class Card {

  constructor() {
    this.html;
    this.generateHTML();
  }

  generateHTML() {
    this.html = document.createElement('div');
    this.html.classList.add('card');
  }

}

class SituationCard extends Card {

  constructor() {

    super();

    this.html.classList.add('situation');
    this.html.innerHTML = `<img src="card-${this.situationIndex}.png" role="presentation">`;
    
    this.timeline.fromTo(this.html, { opacity: 0 }, { opacity: 1, duration: .2 }, 'start')
    this.timeline.fromTo(this.html, { scale: 3 }, { scale: 1, duration: 1, ease: Bounce.easeOut}, 'start');

  }
  
}

class CardsShowcase extends HTMLElement {

  constructor() {

    super();

    this.wrapperCards = document.querySelector('.section.cards .wrapper-cards');
    this.touchElt = document.querySelector('.section.cards .touch');
    this.commentElt = document.querySelector('.section.cards .comment');

    this.ranges;
    this.generated = false;
    this.clickCount = 0;
  
    this.situationCardsHistory = [];
    this.cardsHistory = [];
  
    this.hoverCards = false;
    this.clickCards = false;

    this.setScrollTrigger();

    this.touchTimeline;
    this.setTouchTimeline();

    this.COMMENTS = [
      {
        content: 'Pas mal du tout ! 🌶️'
      },
      {
        content: 'Excellent !'
      },
      {
        content: 'Ouuuh 😏'
      },
      {
        content: 'Ouiii mon gâté !'
      }
    ]

    this.ANSWERS = [
      {
        situation: 'https://cdn.shopify.com/s/files/1/0510/7046/8263/files/card-1.png?v=1688388170',
        prompt: 'Ça ne te gène pas si on dort dans le même lit ?',
        answers: [
          'Franchement je ne te toucherais même pas avec un bâton',
          'T’as de la chance j’ai pris une douche hier',
          'Ce n’est pas comme ça que tu vas arriver à me choper',
          'Je te mettrais bien un coup de bite de l’espace',
          'Non j’ai pas envie de marcher en canard demain',
          'Et moi qui hésitais à me mettre un petit gode ce soir !',
          'Non j’ai un matelas vraiment confortable',
          'Non, mais pour la facture je l’envoie à votre société ?'
        ]
      },
      {
        situation: 'https://cdn.shopify.com/s/files/1/0510/7046/8263/files/card-2.png?v=1688388169',
        prompt: 'Je préfère te prevenir, j\'ai mes règles...',
        answers: [
          'On m’appelle pas fornicator pour rien',
          'C’est toujours mieux qu’une gastro non ?',
          'Encore un coup des francs-maçons ça',
          'J’adore le sang frais',
          'C’est ton jour de chance, je me suis brossé les dents aujourd’hui',
          'Ça va être la plus belle tartiflette de ta vie',
          'J’en jouis d’avance',
          'T’as de la chance j’ai pris une douche hier'
        ]
      },
      {
        situation: 'https://cdn.shopify.com/s/files/1/0510/7046/8263/files/card-3.png?v=1688388170',
        prompt: 'Tu cherches quoi ici ? Moi clairement je veux juste m\'amuser',
        answers: [
          'Clairement je ne suis pas là pour enfiler des perles',
          'Ce que j’ai envie de te faire est illégal dans de nombreux pays',
          'Tu m’excites avec ton message ! A moi maintenant',
          'T’es qui ?',
          'Les grands esprits se rencontrent',
          'Je gagne 150k€ par an, j’ai pas le temps pour ça',
          'Je ne passerai pas la frontière ce soir',
          'Je serai l’écureuil de tes noisettes',
        ]
      },
      {
        situation: 'https://cdn.shopify.com/s/files/1/0510/7046/8263/files/card-4.png?v=1688388169',
        prompt: 'Chérie, je suis enceinte ! Tu vas être papa !',
        answers: [
          'Sorry I don’t speak Spanish',
          'Je m’en bats les couilles',
          'Pour être tout à fait honnête, j’aurais préféré autre chose comme message d’anniversaire !',
          'Va te bourrer la gueule et passe à autre chose',
          'Au top je vais chez Lidl acheter un reblochon',
          'Tu t’es trompée de destinataire ma chérie',
          'Pas le temps de répondre - c’est soirée Ligue des Champions avec les potes',
          'Mince je pensais avoir bloqué ton numéro',
        ]
      }
    ]

    if( SIZE.width < 640 ) {

      // MOBILE
  
      this.ranges = [
      
        // Situation
        { x: 0, y: 0, rotate: -4 },
    
        // Cartes de gauche
        { x: -100, y: -75, rotate: getRandomInterval(-5) },
        { x: -120, y: 50, rotate: getRandomInterval(-10) },
        { x: -60, y: 150, rotate: getRandomInterval(-35) },
        
        // Cartes de droite
        { x: 75, y: -125, rotate: getRandomInterval(5) },
        { x: 110, y: 20, rotate: getRandomInterval(30) },
        { x: 100, y: 150, rotate: getRandomInterval(10) }
      ]
  
    } else {

      // DESKTOP
      
      this.ranges = [
      
        // Situation
        { x: 0, y: 0, rotate: -4 },
    
        // Cartes de gauche
        { x: -600, y: 0, rotate: getRandomInterval(10) },
        { x: -400, y: -50, rotate: getRandomInterval(-5) },
        { x: -200, y: 75, rotate: getRandomInterval(10) },
        
        // Cartes de droite
        { x: 200, y: -50, rotate: getRandomInterval(10) },
        { x: 400, y: 50, rotate: getRandomInterval(0) },
        { x: 600, y: -100, rotate: getRandomInterval(-20) }
      ]
      
    }

  }
    
  createCard({ index=null, type='normal', situationIndex }) {

    const timeline = gsap.timeline();
    timeline.add('start');
    
    const card = new Card().html;

    if(type === 'situation') {

      card.classList.add('situation');
      card.innerHTML = `<img src="${this.ANSWERS[situationIndex].situation}" role="presentation">`;
      
      // On fait apparaître la carte situation avec un effet de dézoom
      timeline.fromTo(card, { opacity: 0 }, { opacity: 1, duration: .2 }, 'start')
      timeline.fromTo(card, { scale: 3 }, { scale: 1, duration: 1, ease: Bounce.easeOut, onComplete: () => {
        this.hoverCards = true;
        this.clickCards = true;
      }}, 'start');

    }
    
    if(type === 'normal') {

      const prompt = this.ANSWERS[situationIndex-1].answers[index-1];
      card.innerHTML = prompt;
      this.cardsHistory.push(prompt);

    }
    
    // On récupère les coordonnées de la carte
    const pos = { x: this.ranges[index].x, y: this.ranges[index].y, rotate: this.ranges[index].rotate }
    
    // On place la carte aux coordonnées renseignées
    timeline.fromTo(card, { x: 0, y: 0, rotate: 0 }, { x: pos.x, y: pos.y, rotate: pos.rotate, duration: 1, ease: Power3.easeInOut }, 'start');
  
    this.wrapperCards.appendChild(card);
  
    card.addEventListener('mouseenter', () => {
      if(this.hoverCards) {
        gsap.to(card, { scale: 1.05, rotate: 0, duration: 1, ease: Elastic.easeOut });
        card.style.zIndex = 2;
      }
    });
  
    card.addEventListener('mouseleave', () => {
      if(this.hoverCards) {
        gsap.to(card, { scale: 1, rotate: pos.rotate, duration: 1, ease: Elastic.easeOut });
        if(type === 'normal') card.style.zIndex = 0;
      }
    });

    if(type === 'normal') {
  
      card.addEventListener('click', () => {

        this.touchTimeline.pause();
        this.touchTimelineEnd();

        this.clickCount++;

        const comment = this.COMMENTS[this.clickCount-1];

        if(comment != null) {

          this.commentElt.innerHTML = comment.content;

          if(comment.emoji != null) {
            this.commentElt.innerHTML += `<img class="emoji" src="${comment.emoji}" role="presentation>`
          }

        }

        if(this.clickCards) {

          this.hoverCards = false;
          this.clickCards = false;

          card.classList.add('selected');

          const otherCards = document.querySelectorAll('.section.cards .card:not(.situation, .selected)');
  
          const tl = gsap.timeline();
          tl.add('start');

          if(SIZE.width < 640) {

            // ANIMATION CLICK MOBILE

            tl.to( card, { x: 65, y: -50, scale: 1.15, rotate: 15, duration: 1, ease: 'elastic.out(1, 0.65)', zIndex: 2 }, 'start');
            tl.to('.section.cards .card.situation', { x: -65, y: -50, scale: 1, rotate: -5, duration: 1, ease: 'elastic.out(1, 0.65)' }, 'start');

            tl.fromTo(this.commentElt, { y: '9em', opacity: 0 }, { y: '8em', opacity: 1, duration: .35, delay: .25, ease: Power2.easeOut }, 'start');

          } else {

            // ANIMATION CLICK DESKTOP

            tl.to( card, { x: 100, y: -25, scale: 1, rotate: 15, duration: 1, ease: 'elastic.out(1, 0.65)', zIndex: 2 }, 'start');
            tl.to('.section.cards .card.situation', { x: -100, y: -25, scale: 1, rotate: -5, duration: 1, ease: 'elastic.out(1, 0.65)' }, 'start');

            tl.fromTo(this.commentElt, { y: '15em', opacity: 0 }, { y: '14em', opacity: 1, duration: .35, delay: .25, ease: Power2.easeOut }, 'start');

          }

          tl.to( otherCards, { x: 0, y: -25, scale: .5, rotate: 0, duration: 1, stagger: 0.05, ease: 'elastic.out(1, 0.65)', onComplete: () => {
            setTimeout(() => {
              removeCollection(otherCards);
              removeCollection(document.querySelectorAll('.section.cards .card:is(.selected, .situation)'));
              this.generateCards();
            }, 400);
          } }, 'start' );

          tl.add('end', '+=.25');
          tl.to(this.commentElt, { y: '7em', opacity: 0, duration: .75, ease: 'elastic.out(1, 0.65)' }, 'end');
          tl.to( '.section.cards .card.situation', { x: 0, y: 0, scale: .85, rotate: -2, duration: .75, ease: 'elastic.out(1, 0.65)' }, 'end');
          tl.to( card, { x: 0, y: 0, scale: 1, rotate: 2, duration: .75, ease: 'elastic.out(1, 0.65)'}, 'end');

        }
        
      });

    }
  
  }
    
  generateCards() {

    const situationIndex = getRandomIntBetween(1, 4);
    this.situationCardsHistory.push(situationIndex);

    this.createCard({
      index: 0,
      type: 'situation',
      situationIndex
    });
    
    for(let i=1; i<=6; i++) {
      this.createCard({
        index: i,
        type: 'normal',
        situationIndex
      });
    }
  
  }

  setTouchTimeline() {

    this.touchTimeline = gsap.timeline({ repeat: -1 });
    this.touchTimeline.to(this.touchElt, { scale: .85, opacity: .5, duration: .25 });
    this.touchTimeline.to(this.touchElt, { scale: 1, opacity: 1, duration: .15 });
    this.touchTimeline.to(this.touchElt, { scale: .85, opacity: .5, duration: .25 });
    this.touchTimeline.to(this.touchElt, { scale: 1, opacity: 1, duration: 1 });

  }

  touchTimelineEnd() {

    gsap.to(this.touchElt, { scale: 1, opacity: 0, duration: .5 });

  }

  setScrollTrigger() {
    
    ScrollTrigger.create({
      trigger: '.section.cards',
      start: "50% 50%",
      onEnter: () => {
        if(!this.generated) {
          this.generateCards();
          this.generated = true;
        }
      }
    });
    
  }
  
}

customElements.define('cards-showcase', CardsShowcase);

// =================== HEADER =================== //

class MainHeader extends HTMLElement {

  constructor() {
    super();
    this.bandeau;
    this.setBandeau();
  }

  setBandeau() {

    this.bandeau = new Splide( this.querySelector('.bandeau'), {
      type: 'loop',
      perPage: 1,
      arrows: false,
      pagination: false,
      autoplay: true,
      interval: 2000
    } );

    this.bandeau.mount();

  }
  
}

customElements.define('main-header', MainHeader);

// =================== EDITIONS =================== //

class EditionsWrapper extends HTMLElement {

  constructor() {
    super();
    this.timeline;
    this.setTimeline();
  }

  setTimeline() {

    this.timeline = gsap.timeline();
    this.timeline.add('start');
    this.timeline.fromTo('.section.editions', { backgroundPosition: 'center -400px' }, { backgroundPosition: 'center 0px', scale: 1, duration: 1, ease: Power0.easeNone }, 'start');

    ScrollTrigger.create({
      trigger: '.section.editions',
      animation: this.timeline,
      start: '-=100%',
      end: 'bottom top',
      scrub: true,
    });

    // this.timeline = gsap.timeline();
    // this.timeline.add('start');
    // this.timeline.fromTo('.section.editions .background', { y: 0 }, { y: 400, scale: 1, duration: 1, ease: Power0.easeNone }, 'start');
    // this.timeline.fromTo('.section.editions .box.left', { x: 50, y: 200, rotate: -5 }, { x: 0, y: 0, rotate: -15, duration: 1, ease: Power0.easeNone }, 'start');
    // this.timeline.fromTo('.section.editions .box.right', { x: -50, y: 200, rotate: 5 }, { x: 0, y: 0, rotate: 15, duration: 1, ease: Power0.easeNone }, 'start');
    // this.timeline.fromTo('.section.editions .box.center', { y: 200 }, { y: -200, duration: 1, ease: Power0.easeNone }, 'start');

    // ScrollTrigger.create({
    //   trigger: '.section.editions',
    //   animation: this.timeline,
    //   start: 'top top',
    //   end: '+100%',
    //   scrub: true,
    // });
    
  }
  
}

customElements.define('editions-wrapper', EditionsWrapper);

// =================== GAMES =================== //

let splideGames;

class GamesList extends HTMLElement {

  constructor() {
    
    super();

    this.handElement = document.querySelector('.section.games .hand');
    this.timeline;

    this.setSlider();
    this.setEvents();
    if(SIZE.width > 640) {
      this.setTimeline();
    }

  }

  setSlider() {

    splideGames = new Splide( this, {
      type: 'loop',
      perPage: 1,
      arrows: false,
      pagination: false,
      breakpoints: {
        640: {
          arrows: true
        }
      }
    } );

    splideGames.mount();
    
  }

  animateHand() {
    
    const tl = gsap.timeline();
    tl.to(this.handElement, { y: 30, duration: .15 });
    tl.to(this.handElement, { y: 0, duration: .15 });

  }

  setTimeline() {

    const introTL = gsap.timeline();
    introTL.add('start');
    introTL.fromTo('.section.games .illu .box', { y: 200, rotate: 10, rotateY: -20 }, { y: -300, rotate: -20, rotateY: 40, duration: 1, ease: Linear.easeNone }, 'start');
    introTL.fromTo('.section.games .hand', { rotate: -25 }, { rotate: 10, duration: 1, ease: Linear.easeNone }, 'start');

    ScrollTrigger.create({
      trigger: '.section.games',
      animation: introTL,
      start: 'top bottom',
      end: 'bottom top',
      scrub: true,
    });

  }

  setEvents() {

    splideGames.on('move', newIndex => {

      removeClass('.section.games .menu .item', 'active')
      document.querySelector(`.section.games .menu .item:nth-child(${newIndex+1})`).classList.add('active');

      this.animateHand();

      if(SIZE.width < 640) {

        const timeline = gsap.timeline();
        timeline.add('start');
        timeline.to('.section.games .game .box', { y: 100, duration: 1, ease: 'elastic.out(1, 0.65)' }, 'start');
        timeline.fromTo('.section.games .game .card.left', { x: -50, y: 100, rotate: -10 }, { x: -115, y: 0, rotate: -20, duration: 1, ease: 'elastic.out(1, 0.65)' }, 'start');
        timeline.fromTo('.section.games .game .card.right', { x: 50, y: 100, rotate: 10 }, { x: 115, y: 0, rotate: 20, duration: 1, ease: 'elastic.out(1, 0.65)' }, 'start');
        timeline.fromTo(`.section.games .game-${newIndex+1} .box`, { y: 100 }, { y: 0, duration: 1, ease: 'elastic.out(1, 0.65)' }, 'start');

      }

    });

  }
  
}

customElements.define('games-list', GamesList);

class GamesMenuItem extends HTMLElement {

  constructor() {
    
    super();
    this.setEvents();

  }

  setEvents() {

    this.addEventListener('click', () => {

      const index = Number(this.dataset.index);
      removeClass('.section.games .menu .item', 'active');
      this.classList.add('active');
      
      splideGames.go(index-1);

    });

  }
  
}

customElements.define('games-menu-item', GamesMenuItem);

// =================== YOUTUBE =================== //

class HeadStory extends HTMLElement {

  constructor() {
    super();
    this.type = this.dataset.type;
    this.link = this.dataset.link;
    this.setEvents();
  }

  setEvents() {
    this.addEventListener('click', () => {
      if(this.type === 'youtube') {
        document.querySelector('iframe').src = this.link;
      }
    });
  }
  
}

customElements.define('head-story', HeadStory);

if(document.querySelector('.section.youtube') != undefined) {

  new Splide( '.section.youtube .splide', {
    type   : 'loop',
    perPage: 7,
    arrows: false,
    pagination: false,
    gap: 20,
    arrows: true,
    autoplay: true,
    interval: 2000,
    breakpoints: {
      640: {
        perPage: 4,
        gap: 15,
        padding: 30,
        arrows: false,
      }
    }
  } ).mount();

}

// =================== TESTIMONIES =================== //

class ClientsTestimonies extends HTMLElement {

  constructor() {
    super();
    this.slider;
    this.timeline;
    this.setSlider();
  }

  setSlider() {

    this.slider = new Splide( this.querySelector('.splide'), {
      type: 'loop',
      perPage: 3,
      arrows: false,
      pagination: true,
      autoplay: true,
      interval: 2000,
      breakpoints: {
        640: {
          perPage: 1,
          padding: 0
        }
      }
    } );

    this.slider.mount();

    let count = 0;

    this.slider.on('move', function () {

      count++;

      if(count > 3) count = 1;

      const timeline = gsap.timeline();
      timeline.add('start');
      timeline.to(`.section.testimonies .background img`, { opacity: 0, duration: .5 }, 'start');
      timeline.to(`.section.testimonies .background img:nth-child(${count})`, { opacity: 1, duration: .5 }, 'start');

    });

  }
  
}

customElements.define('clients-testimonies', ClientsTestimonies);

// =================== RULES =================== //

if(document.querySelector('.section.rules') != undefined) {

  if(SIZE.width < 640) {

    const splideRules = new Splide( '.section.rules .splide', {
      type: 'slide',
      perPage: 1,
      arrows: true,
      pagination: false,
    } ).mount();

    let index = 0;

    splideRules.on( 'move', function (newIndex, prevIndex) {

      if(index != newIndex) {
      
        if(newIndex === 0) {

          const tl = gsap.timeline();
          tl.add('start')
          tl.to('.section.rules .illu .polaroid.left', { x: -100, y: -25, rotate: -5, duration: .5, ease: Power2.easeInOut }, 'start');
          tl.to('.section.rules .illu .polaroid.right', { x: 100, y: 25, rotate: 5, duration: .5, ease: Power2.easeInOut }, 'start');

          tl.to('.section.rules .card.situation', { y: -400, duration: 1 }, 'start');

        }
        
        if (newIndex === 1) {

          const tl = gsap.timeline();

          if(prevIndex === 0) {

            tl.add('start')
            tl.to('.section.rules .illu .polaroid.left', { x: '-22em', rotate: -25, duration: .5, ease: Power2.easeInOut }, 'start');
            tl.to('.section.rules .illu .polaroid.right', { x: '22em', rotate: 25, duration: .5, ease: Power2.easeInOut }, 'start');

            tl.add('situation');
            tl.fromTo('.section.rules .step:nth-child(2) .player', { opacity: 1 }, { opacity: .5, duration: .5 }, 'situation');
            tl.fromTo('.section.rules .step:nth-child(2) .player:nth-child(1)', { marginRight: 0, scale: 1 }, { marginRight: 25, scale: 1.15, opacity: 1, duration: .5 }, 'situation');
            tl.fromTo('.section.rules .card.situation', { scale: 3, opacity: 0 }, { y: 0, scale: .75, opacity: 1, rotate: 10, duration: .5, ease: Power2.easeInOut }, 'situation');

          }

          if(prevIndex === 2) {

            tl.add('vanish');
            tl.to('.section.rules .card-1', { x: -300, duration: .5 }, 'vanish');
            tl.to('.section.rules .card-2', { x: -300, duration: .5 }, 'vanish');
            tl.to('.section.rules .card-3', { x: 300, duration: .5 }, 'vanish');
            tl.to('.section.rules .card-4', { x: 300, duration: .5 }, 'vanish');

          }

        }

        if (newIndex === 2) {

          const tl = gsap.timeline();

          if(prevIndex === 1) {
          
            for(let i=1; i<=4; i++) {

              tl.add(`player${i}`);
              tl.to('.section.rules .player', { opacity: .5, duration: .5 }, `player${i}`);
              tl.to(`section.rules .slide:nth-child(3) .player:nth-child(${i})`, { opacity: 1, duration: .5 }, `player${i}`);
              
            }
  
            tl.to(`section.rules .illu .card-1`, { x: -150, y: -25, scale: .75, opacity: 1, rotate: -20, duration: .5, ease: Power2.easeInOut }, `player1`);
            tl.to(`section.rules .illu .card-2`, { x: -75, y: 25, scale: .75, opacity: 1, rotate: 10, duration: .5, ease: Power2.easeInOut }, `player2`);
            tl.to(`section.rules .illu .card-3`, { x: 75, y: -25, scale: .75, opacity: 1, rotate: -10, duration: .5, ease: Power2.easeInOut }, `player3`);
            tl.to(`section.rules .illu .card-4`, { x: 150, y: 25, scale: .75, opacity: 1, rotate: 30, duration: .5, ease: Power2.easeInOut }, `player4`);
  
            tl.to('.section.rules .player', { opacity: 1, duration: .5 });

          }

          if(prevIndex === 3) {

            tl.add('win');
            tl.to('.section.rules .card-4', { x: 150, y: 25, scale: .75, rotate: 30, zIndex: 1, duration: .5, ease: Power2.easeInOut }, 'win');

          }

        }

        if(newIndex === 3) {

          const tl = gsap.timeline();

          tl.add('win');
          tl.to('.section.rules .card-4', { x: 0, y: 0, rotate: 5, scale: 1.15, zIndex: 2, duration: .5 }, 'win');

        }

        index = newIndex;

      }
      
    } );

  } else {

  }

}

// ==================== TRANSITION ==================== //

class SliderFeatures extends HTMLElement {
  
  constructor() {
    super();
    this.setSlider();
  }

  setSlider() {

    new Splide( this, {
      type: 'loop',
      perPage: 3,
      arrows: false,
      pagination: true,
      gap: 25,
      updateOnMove: true,
      breakpoints: {
        1280: {
          perPage: 1,
          padding: 150
        },
        640: {
          perPage: 1,
          padding: 40
        }
      }
    } ).mount();

  }

}

customElements.define('slider-features', SliderFeatures);

// ==================== STICKY FEATURE ==================== //

class StickyFeatures extends HTMLElement {

  constructor() {
    super();
    this.timeline;
    this.setTimeline();
  }

  setTimeline() {

    ScrollTrigger.create({
      trigger: '.section.sticky-features',
      start: '20% center',
      scrub: true,
      onEnter: () => {
        gsap.to('.section.sticky-features .greta.no-smile', { opacity: 0, duration: 0, ease: Linear.easeNone });
      }
    });

    for(let feature of this.querySelectorAll('.sticky-feature')) {

      const timeline = gsap.timeline();
      timeline.add('check');
      timeline.fromTo(feature.querySelector('.check img'), { scale: 0, rotate: 100 }, { scale: 1, rotate: 0, duration: 1, ease: 'elastic.out(1, 0.65)' }, 'check');

      ScrollTrigger.create({
        trigger: feature,
        animation: timeline,
        start: 'top 25%'
      });

    }

    // this.timeline = gsap.timeline();
    // this.timeline.add('start');
    // this.timeline.fromTo('.sticky-features-container', { y: 0 }, { y: 200, duration: 1, ease: Linear.easeNone }, 'start');

    // if(SIZE.width < 640) {

    //   ScrollTrigger.create({
    //     trigger: '.sticky-feature:last-child',
    //     animation: this.timeline,
    //     start: '-200px top',
    //     scrub: true,
    //   });

    // } else {

    //   ScrollTrigger.create({
    //     trigger: '.sticky-feature:last-child',
    //     animation: this.timeline,
    //     start: 'top top',
    //     scrub: true,
    //   });

    // }

  }
  
}

customElements.define('sticky-features', StickyFeatures);

// ==================== TRANSITION ==================== //

class TransitionSlider extends HTMLElement {
  
  constructor() {
    super();
    this.timeline;
    this.setTimeline();
  }

  setTimeline() {

    if(SIZE.width < 640) {

      this.timeline = gsap.timeline();
      this.timeline.add('start');
      this.timeline.fromTo('.section.transition .polaroid:nth-child(1)', { x: -250, rotate: -20 }, { x: 0, rotate: 2, duration: 1, ease: Power2.easeInOut }, 'start');
      this.timeline.fromTo('.section.transition .polaroid:nth-child(2)', { x: 250, rotate: 20 }, { x: 0, rotate: -2, duration: 1, ease: Power2.easeInOut }, 'start');
  
      ScrollTrigger.create({
        trigger: '.section.transition',
        animation: this.timeline,
        start: 'top center',
        onEnter: () => this.timeline.play()
      });

    }

  }

}

customElements.define('transition-slider', TransitionSlider);

// ==================== FAQ ==================== //

class FAQButton extends HTMLElement {
  
  constructor() {
    super();
    this.setEvents();
  }

  setEvents() {
    this.addEventListener('click', () => {
      for(let question of document.querySelectorAll('.section.faq .hidden')) {
        question.classList.remove('hidden');
      }
      this.classList.add('hidden');
    });
  }

}

customElements.define('faq-button', FAQButton);

class FAQQuestion extends HTMLElement {
  
  constructor() {
    super();
    this.setEvents();
  }

  setEvents() {
    this.addEventListener('click', () => {
      this.classList.toggle('active');
    });
  }

}

customElements.define('faq-question', FAQQuestion);

// =================== SOCIAL =================== //

class SocialSlider extends HTMLElement {

  constructor() {
    super();
    this.setSlider();
  }

  setSlider() {

    new Splide( this, {
      type: 'loop',
      perPage: 4,
      arrows: true,
      pagination: false,
      padding: 75,
      gap: 20,
      breakpoints: {
        640: {
          perPage: 1
        }
      }
    } ).mount();

  }
  
}

customElements.define('social-slider', SocialSlider);

// =================== ORDER =================== //

class SectionOrder extends HTMLElement {

  constructor() {
    super();
    this.timeline;
    this.setTimeline();
  }

  setTimeline() {

    this.timeline = gsap.timeline();
    this.timeline.add('start');
    this.timeline.to('.section.order .hand.left', { rotate: 50, duration: 1, ease: Linear.easeNone }, 'start');
    this.timeline.to('.section.order .hand.right', { rotate: -50, duration: 1, ease: Linear.easeNone }, 'start');

    ScrollTrigger.create({
      trigger: this,
      animation: this.timeline,
      start: 'top bottom',
      end: 'bottom top',
      scrub: true,
    });

  }
  
}

customElements.define('section-order', SectionOrder);

/* ==================== PROMO ==================== */

class PromoSlider extends HTMLElement {
  
  constructor() {
    super();
    this.init();
  }

  init() {
    this.setSlider();
  }

  setSlider() {

    new Splide(this, {
      type: 'loop',
      perPage: 1,
      arrows: false,
      pagination: false
    }).mount();
    
  }

}

customElements.define('promo-slider', PromoSlider);
